var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealthEdu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#084F8A",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 10L8.66663 14L11.3333 15.4533V19.4533L16 22L20.6666 19.4533V15.4533L22 14.7267V19.3333H23.3333V14L16 10ZM20.5466 14L16 16.48L11.4533 14L16 11.52L20.5466 14ZM19.3333 18.66L16 20.48L12.6666 18.66V16.18L16 18L19.3333 16.18V18.66Z",
    fill: "#027BCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthEdu);
export default __webpack_public_path__ + "static/media/healthEdu.da7f76693f2ce803d5296c6fd4bcbef0.svg";
export { ForwardRef as ReactComponent };